import without from 'lodash/without'
import createSearchString from '@/utils/createSearchString'

export default {
  data () {
    return {
      // must be overriden
      restService: undefined,
      itemType: undefined,

      // usually to be overriden
      idField: 'id',
      searchFields: ['id'],

      // other
      items: [],
      filteredItems: [],
      currentItem: undefined,
      modifiedItemsKeys: [],
      newItemNameIterator: 1,
      idValidator: undefined,
      lastSearchString: ''
    }
  },
  created () {
    this.reloadItems()

    // prepare id validator
    this.idValidator = (newId, oldId) => {
      return (this.items || []).map(t => t[this.idField]).filter(i => i !== oldId).indexOf(newId) < 0
    }
  },
  methods: {
    reloadItems () {
      this.restService.getItems(this.itemType).then(loadedItems => {
        this.items = loadedItems

        // make search strings
        this.items.forEach(t => {
          t.searchString = createSearchString(t, ...this.searchFields)
        })

        this.onSearch(this.lastSearchString)
      })
    },
    onChangeSelected: function (newSelected) {
      this.currentItem = newSelected
    },
    onModified: function (data) {
      let index = this.modifiedItemsKeys.indexOf(data.item[this.idField])
      if (data.modified) {
        if (index < 0) {
          this.modifiedItemsKeys.push(data.item[this.idField])
        }
      } else {
        if (index >= 0) {
          this.modifiedItemsKeys.splice(index, 1)
        }
      }
      this.debug && console.log('this.modifiedItemsKeys ', this.modifiedItemsKeys)
    },
    onItemChanged: function (changedItem) {
      changedItem.searchString = createSearchString(changedItem, ...this.searchFields)
      let index = this.filteredItems.map(t => t[this.idField]).indexOf(changedItem[this.idField])
      this.$set(this.filteredItems, index, changedItem)
      if (changedItem[this.idField] === this.currentItem[this.idField]) {
        this.currentItem = this.filteredItems[index]
      }
    },
    onAddEntity: function () {
      this.filteredItems.unshift(this.createNewItem())
      this.currentItem = this.filteredItems[0]
    },
    createNewItem () {
      return {
        id: this.getNewItemId(),
        isNew: true,
        edit: [this.idField]
      }
    },
    getNewItemId: function () {
      let newId
      do {
        newId = 'NEW-' + this.newItemNameIterator++
      } while (this.items.filter(t => t[this.idField] === newId).length > 0)
      return newId
    },
    onSearch: function (searchString) {
      if (!searchString || searchString.trim().length < 1) {
        this.filteredItems = [...this.items]
      } else {
        let searchValues = searchString.trim().toLowerCase().split(' ')
        this.filteredItems = this.items.filter(t => searchValues.every(function (sv) {
          return t.searchString.indexOf(sv) !== -1
        }))
      }
      this.lastSearchString = searchString
    },
    onItemDeleted (itemToDelete) {
      if (itemToDelete.isNew) {
        this.filteredItems = without(this.filteredItems, itemToDelete)
      } else {
        this.reloadItems()
      }
      this.modifiedItemsKeys = without(this.modifiedItemsKeys, itemToDelete[this.idField])
      this.currentItem = undefined
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/mixins/entityPageMixin.js